<template>
  <div :class="selector"
       class="side-help-tooltips">
    <transition name="group-fade">
      <HelpFloat v-if="isFixed"
                 :title="title"
                 @toggle-tooltip="onToggle"
                 class="side-help-tooltips__help-float"/>
    </transition>
    <div class="side-help-tooltips__wrap">
      <button v-if="isFixed"
              type="button"
              class="side-help-tooltips__close"
              @click.prevent="onToggle">
        <span class="side-help-tooltips__close-text">{{$tGlobal('Close')}}</span>
        <span class="side-help-tooltips__close-ico">
          <BaseSvg name="ico-close"/>
        </span>
      </button>
      <HelpTooltip :src="src"
                   :title="title"
                   :description="description"
                   class="side-help-tooltips__inner"/>
    </div>
  </div>
</template>

<script>
  import windowSizeMixin from '../mixins/windowSizeMixin'
  import {blockScroll, unBlockScroll} from '../helpers/scroll'
  import HelpFloat from './HelpTooltipFloat'
  import HelpTooltip from './HelpTooltip'
  import img1 from '../assets/img/account-settings/img_01.png'

  export default {
    name: 'SettingsSide',
    mixins: [windowSizeMixin],
    components: {
      HelpFloat,
      HelpTooltip
    },
    props: {
      isPartner: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        isOpen: false,
        src: img1,
        title: this.$tSettings('How smart search works'),
        description: `<p>${this.$tSettings('hint_text')}</p>`,
      }
    },
    computed: {
      isFixed() {
        return this.windowSizeMixin.width <= process.env.VUE_APP_WINDOW_SIZE_SM
      },
      selector() {
        return {
          '_fixed': this.isFixed,
          '_open': this.isOpen
        }
      },
    },
    methods: {
      onToggle() {
        if (this.isOpen) {
          unBlockScroll()
          this.isOpen = false
        } else {
          blockScroll()
          this.isOpen = true
        }
      }
    }
  }
</script>

<style lang="less">

</style>
